import React, { useContext, useLayoutEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { MyThemeContext } from './context/theme-context';
import CssBaseline from '@mui/material/CssBaseline';
import './styles/quillesShared.css';
import './styles/newResults.css';

import About from './pages/About';
import Home from './pages/Home';
import NewResultatsEquipes from './pages/NewResultatsEquipes';
import {
	RedirectCloneListToModern,
	RedirectClonePlayerToModern,
	RedirectCloneTeamToModern,
} from './components/RedirectCloneRoutes';

const GA_MEASUREMENT_ID = 'G-SHBDZ9THFK';

function AnalyticsRouteTracker() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname === '/new-resultats-equipes') return;
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      send_to: GA_MEASUREMENT_ID,
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  const { themeContext } = useContext(MyThemeContext);  

  return (
    <>
      <ThemeProvider theme={themeContext}>
        <CssBaseline />
        <BrowserRouter>
            <AnalyticsRouteTracker />
            <Routes>
              <Route path='/about' element={<About />} />
              <Route path='/home' element={<Home />} />
              <Route path='/new-resultats-equipes' element={<NewResultatsEquipes />} />
              <Route path='/resultats-equipes' element={<RedirectCloneListToModern />} />
              <Route path='/resultats-equipes/equipe/:teamNumber' element={<RedirectCloneTeamToModern />} />
              <Route path='/resultats-equipes/joueur/:licence' element={<RedirectClonePlayerToModern />} />
              <Route path='*' element={<Navigate to='/home' />} />
            </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
